import { atom } from "jotai";

 export const procesosAtom = atom([]);
 export const visibleModalLinkAtom =atom(false);
 export const enlacePostulanteAtom = atom (undefined);
